import { useQueryClient, useMutation } from "@tanstack/react-query";
import api from "@/lib/api-client";
import { toast } from "react-toastify";

const deleteAvailability = async (availabilityGuid) => {
    await api.delete(`/Clinician/Availability/${availabilityGuid}`);
};

export const useDeleteAvailability = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deleteAvailability,
        retry: 1,
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ["availability"],
            });
            toast.success("Slot successfully deleted");
        },
        onError: () => {
            toast.error("Error deleting slot");
        },
    });
};
